<template>
  <div class="activity-container">
    <header class="mycase-header" v-if="showHeader">
      <van-nav-bar
          :title="activityTittle"
          left-arrow
          @click-left="handleBlack"
          safe-area-inset-top
          right-text="分享"
          @click-right="handleShare"
      >
      </van-nav-bar>
    </header>
    <div class="handle-article">
      <div @click="handleShare">
        <icon-svg iconClass="iconshare-2" class="share" />分享
      </div>
    </div>
    <article class="case-details" v-if="loadingCase">
      <van-tabs :border="false" swipeable background="#fff" title-active-color="rgb(255, 110, 1)" @change="changeTabs">
        <van-tab title="活动详情">
            <div class="case-base-info">
              <!-- 名片 -->
              <van-sticky :offset-top="topSpace">
                <van-skeleton title avatar :row="3" v-if="showSkeleton"></van-skeleton>
                <div v-else class="case-namecard" >
                  <div class="img-name" @click="loadUserCard">
                    <img
                        :src="
                  oneCase.userCard.headImgUrl
                    ? `${imgUrl}/${oneCase.userCard.headImgUrl}`
                    : morenHeadImg
                "
                        alt=""
                    />
                    <div class="creater-info">
                      <p>{{ oneCase.userCard.name }}</p>
                      <p>{{ oneCase.userCard.merchantName }}</p>
                    </div>
                  </div>
                  <div class="create-describe">
                    <span>{{ isFold ? foldSynopsisStr : synopsisStr }}</span>
                    <span style="color:#999" @click="handleIsFold" v-if="synopsisStr.length>40">{{
                        isFold ? "...展开" : "&lt;&lt;折叠"
                      }}</span>
                  </div>
                </div>
              </van-sticky>
            </div>
            <div class="case-design">
              <div v-for="it in activityFileList" :key="it.fileId">
                <video v-if="it.type=='.mp4'" controls :src="it.url" :poster="VUE_APP_WATCH_FILE_API + '/' + it.coverUrl" style="width: 100%">
                </video>
                <img v-else :src="it.url" style="display: block;width: 100%" @click="handleShowForm(it)">
              </div>
            </div>
        </van-tab>
        <van-tab title="传播轨迹">
          <div :class="['related-clues','bc-change']"  >
            <p v-if="withClueList.length">关联线索</p>
            <van-list v-if="withClueList.length">
              <van-cell v-for="it in withClueList" :key="it">
                <div class="clues-box">
                  <div class="img-name">
                    <img
                        :src="it.headImgUrl ? it.headImgUrl : morenHeadImg"
                        alt=""
                    />
                    <div class="creater-info">
                      <p>{{ it.name }} {{
                          it.phone
                              ? `${it.phone.slice(0, 3)}****${it.phone.slice(7)}`
                              : ""
                        }}</p>
                    </div>
                  </div>
                  <div class="clues-details" @click="loadCuleSDetail(it.clueId)">
                    <p>
                      浏览时间：{{
                        it.browseTime
                            ? `${it.browseTime.slice(0, 10)} ${it.browseTime.slice(
                            11,
                            19
                            )}`
                            : ""
                      }}
                    </p>
                    <div style="display: flex;justify-content: space-between">
                      <p style="width: 150px">浏览时长：{{ it.browseSecond }}秒</p>
                      <p style="width: 150px">浏览位置：{{it.clueShareSource}}</p>
                    </div>
                    <div style="display: flex;justify-content: space-between">
                      <p style="width: 150px">分享人：{{ it.createName }}</p>
                      <p style="width: 150px">推荐人：{{it.recommend_Name}}</p>
                    </div>
                    <div v-if="it.leaveInformation==1">
                      <p v-for="item in it.formMsgList" :key="item.sort">{{item.formName+'：'}}{{item.formMsg}}</p>
                    </div>

                  </div>
                </div>
              </van-cell>
            </van-list>
            <div v-else class="no-clues">
              <img :src="nodataImg">
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <van-overlay :show="showEditForm" @click="showEditForm = false">
        <div class="form-wrapper" @click.stop>
          <div class="form" >
            <img src="../../assets/images/activity_write_form.png">
            <div class="form-body">
              <div class="form-item" v-for="it in activityFormList" :key="it.formId">
                <span class="label">{{ it.formName+":" }}</span>
                <div class="padding-left">
                  <van-field v-if="it.formTypeId===1" v-model="it.selectValue" label="" placeholder="请输入" />
                  <span v-if="it.formTypeId===2" style="color: #289fff;margin-top: 5px" @click="selectTime(it)">{{it.selectValue?it.selectValue:"请选择时间"}}</span>
                  <van-radio-group v-if="it.formTypeId===3&&!it.hasMultiple" v-model="it.selectValue" direction="horizontal">
                    <van-radio v-for="(item,index) in it.formValue" :key="index" :name="item" icon-size="18px">{{ item }}</van-radio>
                  </van-radio-group>
                  <van-checkbox-group v-if="it.formTypeId===3&&it.hasMultiple" v-model="it.selectValue" direction="horizontal">
                    <van-checkbox v-for="(item,index) in it.formValue" :key="index" :name="item" shape="square" icon-size="18px">
                      {{ item }}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
              <div class="button-size">
                <van-button type="primary" size="large" @click="submitForm">提交</van-button>
              </div>
            </div>
            <van-icon name="close" style="color: #FFFFFF;font-size: 26px;margin-top: 24px" @click="closeForm"/>
          </div>
        </div>
      </van-overlay>

    </article>
    <!-- 弹出分享框 -->
    <div class="share_box">
      <!--    分享海报-->
      <div class="wrapperPoster" id="saveposter" style="z-index: 9999" v-if="showOverlay">
        <div class="poster-details" v-if="showImg" ref="imageWrapper">
          <img :src="posterPic" crossOrigin="anonymous"/>
          <div class="text-qrcode">
            <div class="user-info-tag">
              <div class="user-info">
                <img :src="headImgUrl">
                <div class="left-text">
                  <p>{{ userForm.name }}</p>
                  <p>{{ userForm.merchantName }}</p>
                </div>
              </div>
              <div class="user-tag">
                <span class="user-tag-item" v-for="(it,index) in userTags" :key="index">{{ it }}</span>
              </div>
            </div>
            <div class="qrCodeUrl-all">
              <div class="qrCodeUrl-cls">
                <img v-if="qrCodeUrl" :src="qrCodeUrl"/>
              </div>
              <p>立即扫码</p>
              <p>了解更多内容</p>
            </div>
          </div>
        </div>
        <div v-else class="posterImg-hb">
          <img class="card-img" :src="imgSrc" ref="cardImgRef" />
        </div>
      </div>
      <van-share-sheet
          v-model:show="showShare"
          title="分享"
          :options="shareOptions"
          cancel-text="取消"
          @select="onSelect"
          safe-area-inset-bottom
      >
      </van-share-sheet>
    </div>
  </div>
</template>
<script>
import {reactive, toRefs, computed, ref, watch, nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  // findBuildSiteByIdApp
} from "../../api/buildSite"
import {
  findActivityApp,
  findActivityClueApp,
  // updateActivity,
  getActivityDetailsUrl,
  reprint
} from "../../api/activity"
// import transformHtml from "../../components/transformHTML.vue";
import { shareActivityToMiniProgram,copyStr,loadImages } from "@/utils/commonUtil";
import { createPosterAppShare,getQrCodeUrl } from "@/api/common";
import {ImagePreview, Toast} from "vant";
import {flutterShowToast} from '../../utils/appChannel'
import {posterShare} from "@/utils/posterShare"
import html2canvas from "html2canvas";
import  {findPosterImg} from "@/api/file"
import {getUserCardByPoster} from "@/api/user/userCard"

export default {
  components: {
    // transformHtml,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const imageWrapper = ref(null);
    const cardImgRef = ref(null);
    const state = reactive({
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 0, 31),
      showTime:false,
      currentDate:'',
      checkList:[],
      radio:null,
      value:"",
      activityFormList:[],
      showEditForm:false,
      activityFileList:[],
      activityTittle:'',
      userForm:{},
      userTags:[],
      headImgUrl:'',
      showSharePoster:false,
      shareJumpUrl:'',
      posterId:'',
      imgSrc:'',
      qrCodeUrl:'',
      posterName:'',
      posterPic:'',
      sharePosterImg:'',
      showOverlay: false,
      showImg: true,
      shareOptions:[],
      defaultImg: require("@/assets/images/activity_default_img.jpg"),
      //=======================分享海报
      showSkeleton:true,
      topSpace: 10,
      withClueList: {},
      coverImage: [],
      imgUrl: process.env.VUE_APP_WATCH_FILE_API,
      morenHeadImg: require("../../assets/icons/Vector.png"),
      morenImg: require('../../assets/images/activity_default_img.jpg'),
      nodataImg:require("../../assets/images/no-data.png"),
      loadingCase: false,
      showShare: false,
      activityId: route.query.activityId,
      oneCase: [],
      options: [
        { name: "微信", icon: require("@/assets/icons/weChat2.png") },
        { name: "朋友圈", icon: require("@/assets/icons/friends2.png") },
        { name: "复制链接", icon: require("@/assets/icons/copy-link.png") },
        { name: "分享海报", icon: require("@/assets/icons/share_poster.png") },
      ],
      posterOptions: [
        {name: "微信分享", icon: require("@/assets/icons/weChat2.png")},
        {name: "朋友圈分享", icon: require("@/assets/icons/friends2.png")},
      ],
      synopsisStr: "",
      foldSynopsisStr: "",
      isFold: true,
      VUE_APP_WATCH_FILE_API: process.env.VUE_APP_WATCH_FILE_API
    });
    watch(() => state.showShare, (newVal, oldVal) => {
      console.log('新值：',newVal,'老值',oldVal)
      if (state.showShare===false){
        state.showOverlay = false
        state.showImg = true
      }
    })
    const closeForm = ()=>{
      state.showEditForm = false
      // state.showConsulting = false
      // state.active = null;
    }
    const handleShowForm = (it)=>{
      if (it.hasRelation){
        state.showEditForm = true
      }
      console.log("点击的文件===========",it)
    }
    //切换tabs
    const changeTabs=()=>{
      findActivityClueApp(state.activityId).then(res=>{
        state.withClueList = res
      })
    }
    //个人名片
    const loadUserCard = () => {
      router.push(`/userCard`);
    };
    //全景漫游
    const loadPanoramic = () => {
      router.push({
        name: "panoramicWindow",
        query: { panoramicUrl: state.oneCase.panoramicUrl },
      });
    };
    //展开折叠
    const handleIsFold = () => {
      state.isFold = !state.isFold;
    };
    //返回
    const handleBlack = () => {
      if(route.params.addPoster==='true'){
        router.push({
          path:'/activityVisitors',
          name:'activityVisitors',
          params:{
            addPoster:route.params.addPoster
          }
        })
        return
      }
      if(route.params.fromPoster==='true'){
        router.push({
          path:'/activityVisitors',
          name:'activityVisitors',
          params:{
            fromPoster:route.params.fromPoster
          }
        })
        return
      }
      if(route.query.from === 'card'){
        router.back()
      }else{
        if (route.query.comfrom === "search") {
          router.push({
            name: "activitySearch",
            query: {
              searchVal: route.query.searchVal,
              caseType: route.query.caseType,
              twoType: route.query.twoType,
            },
          });
        } else {
          router.push({
            name: "activityVisitors",
            params: {
              caseType: route.query.caseType,
              twoType: route.query.twoType,
              caseTypeStr: route.query.caseTypeStr,
            },
          });
        }
      }

    };

    let showHeader = computed(() => route.query.hideTitleBar != 1);
    if (!showHeader.value) {
      state.topSpace = 0;
    }
    //获取案例详情
    const loadCaseDetails = async () => {
      let result = await findActivityApp(state.activityId);
      // state.posterPic = result.headImgUrl?state.imgUrl+"/"+result.headImgUrl:state.defaultImg
      // state.sharePosterImg = result.headImgUrl?state.imgUrl+"/"+result.smallCoverPic:"https://wca.ujiaku.com/upload/wx/buildSite_default.png"
      state.activityTittle = result.title
      state.activityFileList = result.activityFileList
      state.activityFormList = result.activityFormList
      state.activityFormList.map(it=>{
        if (it.hasMultiple){
          it.selectValue = []
        }else {
          it.selectValue = ''
        }
        if (it.formTypeId===3){
          // it.formName = it.formName.split(',')
          it.formValue = it.formValue.split(',')
        }
      })
      state.posterName = result.title
      state.oneCase = result;
      state.loadingCase = true;
      state.synopsisStr = result.userCard.selfIntro?result.userCard.selfIntro:'我坚信细节决定品质，专业决定价值！如有需求，请随时与我联系！';
      state.foldSynopsisStr = state.synopsisStr.substring(0, 44);
      state.withClueList = [];
      state.coverImage[0] =result.headImgUrl? `${state.imgUrl}/${result.headImgUrl}`:state.morenImg;
      state.showSkeleton = false

      const p = {
        busiId:state.activityId,
        busiCat:'activity',
        groupId:'activityPosterPic',
      }
      findPosterImg(p).then((res)=>{
        if (res.length>0){
          //获取小图
          findPosterImg({
            busiId:state.activityId,
            busiCat:'activity',
            groupId:'activityPosterPic:S',
          }).then((sImg)=>{
            state.sharePosterImg = sImg[0].url?state.imgUrl+"/"+sImg[sImg.length-1].url:"https://wca.ujiaku.com/upload/wx/activity_default_img.jpg"
          })
          state.posterPic = res[0].url?state.imgUrl+"/"+ res[0].url:state.defaultImg
        }else {
          state.posterPic = state.defaultImg
          state.sharePosterImg = "https://wca.ujiaku.com/upload/wx/activity_default_img.jpg"
        }
      })
    };
    loadCaseDetails();

    //线索跳转详情
    const loadCuleSDetail = (id)=>{
      let params = {
        shareType: "openCustomPage",
        pageName: "clue_detail_page",
        param:{ clueId: id},
      };
      flutterShowToast(params)
    }
    //加载封面图
    const loadCoverImage = () => {
      ImagePreview({
        images: state.coverImage,
        showIndex: false,
      });
    };
    const loadPoster = ()=>{
      savePoster()
      setTimeout(()=>{
        Toast.clear()
      })
    }
    //打开分享微信
    const handleShare = () => {
      // router.push({name:'activityShare',params:{id:state.activityId}})
      state.showShare = true;
      state.shareOptions = state.options
      getUserCardByPoster().then(res=>{
        if (res){
          if (res.headImgUrl){
            state.headImgUrl = state.imgUrl+'/'+res.headImgUrl
          }else {
            state.headImgUrl = require("@/assets/poster_headerImg_default.png")
          }
          state.userForm = res
          state.userTags = res.impressionLabel.split(',')
          if (state.userTags.length>4){
            state.userTags = state.userTags.slice(0,4)
          }
        }
      })
      let params = {
        sourceId:state.activityId,//分享的id
        sourceType:6,//来源类别 1-文章 2-案例 3-视频 4-工地
      }
      getQrCodeUrl(params).then((res)=>{
        state.shareJumpUrl = res.jumpUrl
        if(res.qrCodeUrl){
          state.qrCodeUrl = res.qrCodeUrl
        }
        state.showSharePoster = true
      })
    };
    //微信分享
    const onSelect = (index) => {
      // if (index.name === "微信") {
      //   // router.push({path:`/caseShare/${state.activityId}`})
      //   shareCaseToMiniProgram(state.oneCase);
      // }
      if(index.name === "微信分享"||index.name === "朋友圈分享"){
        if(state.showSharePoster===true){
          Toast.loading({
            message: '正在\n打开微信...',
            forbidClick: true,
            duration:3000,
            className:'posterToast',
          });
          let p = {
            sourceId: state.activityId,//分享的id
            sourceType:6,//来源类别 1-文章 2-案例 3-视频 4-工地
            jumpUrl:state.shareJumpUrl
          }
          createPosterAppShare(p).then((res)=>{
            console.log("创建二海报",res)
          })
          let param = {
            imgSrc:state.imgSrc,
            id:state.activityId,
            bigPosterImgUrl:state.sharePosterImg,
          }
          setTimeout(()=>{
            posterShare(index,param)
          })
        }
      }
      else if(index.name === "复制链接"){
        getActivityDetailsUrl(state.activityId).then((res)=>{
          console.log("链接详情",res)
          copyStr(res)
          state.showShare = false
        })
      }else if(index.name === "分享海报"){
        if(state.showSharePoster===true){
          Toast.loading({
            message: '生成海报中...',
            forbidClick: true,
            duration:0,
            className:'posterToast',
          });
          state.shareOptions = state.posterOptions
          // state.showImg = true
          state.showOverlay = true;
          let arr = []
          arr.push(state.posterPic)
          arr.push(state.qrCodeUrl)
          arr.push(state.headImgUrl)
          loadImages(arr,loadPoster)
          // setTimeout(()=>{
          //   savePoster()
          // },200)
        }
      }else {
        reprint({ activityId: state.activityId });
        shareActivityToMiniProgram(state.oneCase, index);
      }
    };
    //画图
    const savePoster = () =>{
      console.log("保存")
      state.showOverlay = true;
      // html2canvasChange()
      nextTick(() => {
        // var canvas2 = document.createElement("canvas");
        let _canvas = imageWrapper.value;
        const box = window.getComputedStyle(_canvas);
        // DOM 节点计算后宽高
        const width = parseInt(box.width, 10);
        const height = parseInt(box.height, 10);
        // 获取像素比
        const scaleBy = DPR();
        // 创建自定义 canvas 元素
        const canvas = document.createElement("canvas");
        // 设定 canvas 元素属性宽高为 DOM 节点宽高 * 像素比
        canvas.width = width * scaleBy;
        canvas.height = height * scaleBy;
        // 设定 canvas css宽高为 DOM 节点宽高
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        html2canvas(_canvas, {
          useCORS: true,
          background: "#ffffff",
          height: document.getElementById('saveposter').scrollHeight,
          windowHeight: document.getElementById('saveposter').scrollHeight,
          canvas,
        }).then((canvas) => {
          var context = canvas.getContext("2d");
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          let dataURL = canvas.toDataURL("image/png");
          state.showImg = false
          nextTick(() => {
            cardImgRef.value.style.width = width + "px";
            cardImgRef.value.style.height = height + "px";
            state.imgSrc = dataURL;
            state.showImg = false
          });
        });
      });
    }
    const DPR = () => {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    };
    return {
      imageWrapper,
      cardImgRef,
      savePoster,
      DPR,
      handleIsFold,
      loadCuleSDetail,
      ...toRefs(state),
      handleBlack,
      handleShare,
      onSelect,
      loadCoverImage,
      loadPanoramic,
      loadUserCard,
      showHeader,
      changeTabs,
      handleShowForm,
      closeForm
    };
  },
};
</script>
<style lang="scss">
.posterToast{
  //color: #289fff;
  z-index: 1000000001 !important;
}
.activity-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
     //padding: 0 16px;
  .form-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .form {
      width: 287px;
      height: 407px;
      border-radius: 16px;
      background-color: #fff;
      .van-button--large{
        height: 42px;
      }
      .button-size{
        margin: 10px auto;
        height: 42px;
        width: 240px;
        border-radius: 8px;
      }
      .form-body{
        position: relative;
        overflow-x: hidden;
        height:280px ;
        .form-item{
          width: 232px;
          min-height: 42px;
          border: 1px solid #BFBFBF;
          border-radius: 4px;
          margin:0 auto;
          margin-bottom: 10px;
          padding:0 5px;
          //padding-top: 12px;
          font-size: 14px;
          display: flex;
          .van-field{
            padding: 0;
            //padding-top: 12px;
          }
          .van-radio{
            margin-bottom: 4px;
          }
          .van-checkbox__label{
            margin-bottom: 4px;
          }
          .label{
            color: #999999;
            flex-shrink: 0;
            //line-height: 42px;
            text-align: right;
            display: block;
            padding-top: 12px;
            width: 80px;
          }
          .padding-left{
            padding-left: 5px;
            padding-top: 12px;
          }
        }
      }
      >img{
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }

    }
  }
  .wrapperPoster{
    //margin-top: 100px;
    height: 400px;
    overflow-x: hidden;
    //position: absolute;
    position: fixed;
    top: 60px;
    //bottom: 0;
    left: 0;
    right: 0;
    .poster-details{
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      width: 250px;
      overflow-x: hidden;
      >img{
        width: 250px;
        display: block;
      }
      .text-qrcode{
        background-color: #ffff;
        display: flex;
        justify-content: space-between;
        padding: 10px;
        flex: 1;
        .user-info-tag{
          .user-info{
            display: flex;
            align-items: center;
            img{
              border-radius: 20px;
              width: 40px;
              height: 40px;
              object-fit: cover;
              flex-shrink: 0;
            }
            .left-text{
              text-align: left;
              //flex: 1;
              margin-left: 4px;
              p {
                margin: 0;
                padding: 0;
              }
              p:nth-child(1){
                font-size: 16px;
                font-weight: 400;
                line-height: 18px;
                color: #333333;
              }
              p:nth-child(2){
                font-size: 10px;
                color: #333333;
                //line-height: 20px;
              }
            }
          }
          .user-tag{
            display: flex;
            flex-wrap: wrap;
            .user-tag-item{
              margin-top: 5px;
              margin-right: 5px;
              //padding-left: 5px;
              padding:2px 5px;
              color: #289FFF;
              background-color: #E6ECFF;
              font-size: 9px;
              border-radius: 4px;
            }
          }
        }


        .qrCodeUrl-all{
          //position: relative;
          //text-align: center;
          //height: 60px;
          border-left: 1px solid #F1F3F6;
          padding-left: 18px;
          margin-left: 8px;
          flex-shrink:0;
          .qrCodeUrl-cls{
            //width: 60px;
            //height: 60px;
            background-color: #FFFFFF;
            border-radius: 30px;
            //position: relative;
            //top: -33px;
            //text-align: center;
            img{
              width: 60px;
              //border-radius: 25px;
              //position: relative;
              //margin-top: 50%;
              //transform: translateY(-50%);
            }
          }
          >p{
            //position: relative;
            text-align: center;
            font-size: 10px;
            font-weight: 400;
            color: #666666;
            margin: 0;
            //top: -40px;
          }
        }
      }

    }
    .posterImg-hb{
      height: 400px;
      overflow-x: hidden;
    }
  }
  .mycase-header {
    font-size: 18px;
    .van-nav-bar__arrow {
      color: #333333;
    }
    .van-nav-bar__title {
      color: #333333;
      font-weight: 600;
    }
  }
  .handle-article {
    position: fixed;
    right: 0;
    bottom: 110px;
    z-index: 100;
    div {
      height: 28px;
      width: 54px;
      color: #ffffff;
      font-size: 12px;
      opacity: 0.6;
      border-radius: 50px 0 0 50px;
      margin: 10px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    div:nth-child(1) {
      background: #ff6e01;
    }
    div:nth-child(2) {
      background: #ff6e01;
    }
  }
  .case-details {
    flex: 1;
    overflow-x: hidden;
    height: 100%;
    .van-tabs__line{
      background-color: #ff6e01;
    }
    .case-base-info {
       //padding: 0 16px;
      //border-bottom: 1px solid #f7f7f7;
      //height: 100%;
      position: relative;
      .case-namecard {
        background-color: #ffff;
        margin: 0 16px;
        margin-bottom: 10px;
        padding: 0 16px;
        box-shadow: 0px 5px 15px rgb(229, 229, 230);
        border-radius: 8px;
        .img-name {
          height: 40px;
          padding: 5px 0;
          img {
            display: block;
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 20px;
            float: left;
          }
          .creater-info {
            float: left;
            margin-left: 10px;
            font-size: 14px;
            text-align: left;
            p {
              margin: 0;
            }
            > p:nth-child(1) {
              font-weight: 600;
            }
            > p:nth-child(2) {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .create-describe {
          font-size: 12px;
          text-align: left;
          padding: 5px 16px;
        }
      }
    }
    .case-design {

    }

    .related-clues {
      text-align: left;
      padding: 5px 16px;
      background: #f7f7f7;
      .van-cell {
        margin-bottom: 10px;
      }
      > p {
        //  margin: 16px 0;
        margin-top: 5px;
        font-size: 14px;
        font-weight: 600;
      }
      .clues-box {
        //  margin-bottom: 10px;
        .img-name {
          height: 40px;
          padding: 5px 0;
          img {
            display: block;
            height: 40px;
            width: 40px;
            border-radius: 20px;
            float: left;
          }
          .creater-info {
            float: left;
            margin-left: 10px;
            font-size: 14px;
            text-align: left;
            p {
              margin: 0;
            }
            > p:nth-child(1) {
              font-weight: 600;
            }
            > p:nth-child(2) {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .clues-details {
          //   background: #F7F7F7;
          background-color: #f7f7f7;
          padding: 5px;
           p {
            margin: 0;
            font-size: 12px;
          }
        }
      }
      .no-clues{
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 85vh;
        font-size: 24px;
        font-weight: 500;
      }
    }
    .bc-change{
      background: #FFFFFF;
    }
  }
  .share_box {
    .van-share-sheet__cancel::before {
      height: 0;
    }
    .van-share-sheet__cancel {
      height: 48px;
      width: 343px;
      background-color: #f7f7f7;
      color: #333333;
      border-radius: 5px;
      //    position: relative;
      //    transform: translateX(50%);
      margin-left: 15px;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .van-share-sheet__options {
      color: #333333;
      display: flex;
      padding: 0 20px;
      justify-content: space-around;
    }
  }
}
</style>
